import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import * as moment from "moment/moment";
import { ProfileModel } from "@modules/main/components/profile/new-profile/entities/profile-model";

const initialState: ProfileModel | null = null;

@Injectable({
	providedIn: "root"
})
export class NewProfileStateService extends StateService<ProfileModel> {
	constructor() {
		super(initialState);
	}

	public getState$(): Observable<ProfileModel> {
		return this.select((state) => state);
	}

	public updateState(profile: ProfileModel, fullname: string, fullbirthday: string, id: string): void {
		this.setState({
			...profile,
			fullName: fullname,
			fullBirthday: fullbirthday,
			profile_id: id
		});
	}

	public updatePhone(phoneNumber: string): void {
		this.setState({
			...this.state,
			mobile: phoneNumber
		});
	}

	public getBirthday(profile: ProfileModel): string {
		return profile.birthday ? moment.parseZone(profile.birthday.getDate()).format("YYYY.MM.DD") : "";
	}

	public setAcceptedTermsData(b: boolean): void {
		this.setState({
			...this.state,
			accepted_terms_data: b
		});
	}

	public setPhoneNumberVerified(b: boolean): void {
		this.setState({
			...this.state,
			phone_number_verified: b
		});
	}

	public setAcceptedTermsVerification(b: boolean): void {
		this.setState({
			...this.state,
			accepted_terms_verification: b
		});
	}

	public setTenancyTermsVerification(b: boolean): void {
		this.setState({
			...this.state,
			needs_tenancy_terms_approve: b
		});
	}
}
